import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Employee {
  id: number
  fullName: string
  avatar?: { url: string } | null
}

interface ManualEmployeesSelectorProps {
  availableEmployees: Employee[]
  loading: boolean
  value: Array<{ id: number; name: string; avatar?: string }>
  onChange: (selection: EntitySelectEntity[] | EntitySelectEntity | null) => void
}

export const ManualEmployeesSelector = ({
  availableEmployees,
  loading,
  value,
  onChange,
}: ManualEmployeesSelectorProps) => {
  return (
    <EntitySelect
      label={i18n.t('workflows.sidepanel.approval.strategies.selectors.employees')}
      hideLabel
      size="md"
      loading={loading}
      entities={availableEmployees.map((emp) => ({
        id: emp.id,
        name: emp.fullName,
        avatar: buildUrl(emp.avatar?.url),
        expanded: false,
      }))}
      notFoundSubtitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_not_found_subtitle'
      )}
      notFoundTitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_not_found_title'
      )}
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={onChange}
      searchPlaceholder={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_search_placeholder'
      )}
      selectedEntities={value}
      selectedLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_selected_label'
      )}
      singleSelector={false}
      placeholder={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_placeholder'
      )}
      selectedItemsCopy={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_selected_copy'
      )}
      groups={[]}
      selectedGroup="all"
      clearLabel={i18n.t('workflows.sidepanel.approval.strategies.selectors.employees_clear_label')}
      selectAllLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.employees_select_all_label'
      )}
    />
  )
}
